const SoftwareIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3.25" y="4.75" width="17.5" height="14.5" rx="0.75" stroke="black" strokeWidth="0.5"/>
    <circle cx="9.75" cy="8.25" r="0.5" stroke="black" strokeWidth="0.5"/>
    <circle cx="6.75" cy="8.25" r="0.5" stroke="black" strokeWidth="0.5"/>
  </svg>
);

export default SoftwareIcon;
